import React from "react";
import PropTypes from "prop-types";

import CRMPermissionWarning from "scenes/Hubly/components/Workspace/components/CRMPermissionWarning";

const ActiveClientsWrapper = ({
  onClientsClicked,
  crmPermissionWarning,
  numActiveClients,
}) => {
  return (
    <div
      style={{
        fontSize: "12px",
        textDecoration: numActiveClients > 0 ? "underline" : "",
        cursor: numActiveClients > 0 ? "pointer" : "default",
      }}
      onClick={(e) => {
        e.stopPropagation();
        onClientsClicked();
      }}
    >
      {`${numActiveClients} contact${numActiveClients === 1 ? "" : "s"}`}
      {crmPermissionWarning && (
        <CRMPermissionWarning permissionSubject="contacts assigned to this Service Team" />
      )}
    </div>
  );
};

ActiveClientsWrapper.propTypes = {
  onClientsClicked: PropTypes.func.isRequired,
  crmPermissionWarning: PropTypes.bool,
  numActiveClients: PropTypes.number,
};

ActiveClientsWrapper.defaultProps = {
  crmPermissionWarning: false,
  numActiveClients: 0,
};

export default ActiveClientsWrapper;
